export function ReviewStep() {
  return (
    <p style={{ fontWeight: 700, fontSize: 32, textAlign: 'center', margin: '24px 0 0' }}>
      U Got This!
    </p>
  );
}
